/* RELAXIM UI enhancements - global */
(function(){
  'use strict';

  function run(){
    // ============================================================
    // モバイル：ハンバーガーを .header__icons の末尾に移動（1番右に）
    // ============================================================
    if (window.matchMedia('(max-width:768px)').matches) {
      var drawer = document.querySelector('header-drawer');
      var icons  = document.querySelector('.header__icons');
      if (drawer && icons && drawer.parentElement !== icons) {
        icons.appendChild(drawer);
      }
    }

    // ============================================================
    // 追従バナー：スクロール開始直後で早期表示
    // ============================================================
    var sticky = document.querySelector('.product-form-sticky, sticky-buy, .sticky-buy, [class*="sticky-add"]');
    if (sticky) {
      sticky.style.transition = 'transform .3s ease, opacity .3s ease';
      var forceShow = function(){
        if (window.scrollY > 150) {
          sticky.style.transform  = 'translateY(0)';
          sticky.style.opacity    = '1';
          sticky.style.visibility = 'visible';
        }
      };
      window.addEventListener('scroll', forceShow, { passive: true });
      forceShow();
    }

    // ============================================================
    // 検索結果ページ：スクロールぐにゃぐにゃ停止
    // ============================================================
    document.querySelectorAll('main.template-search, .search__container, .predictive-search').forEach(function(el){
      el.style.overscrollBehavior      = 'contain';
      el.style.webkitOverflowScrolling = 'auto';
    });

    // ============================================================
    // 検索結果カード：枠統一（モノクロ）
    // ============================================================
    document.querySelectorAll('main.template-search .card, main.template-search .card-wrapper').forEach(function(c){
      c.style.background   = 'linear-gradient(160deg,#0c0a25,#1a0830 60%,#0a0215)';
      c.style.border       = '1px solid rgba(255,255,255,.08)';
      c.style.borderRadius = '12px';
      c.style.boxShadow    = 'none';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // SPA遷移や遅延ロードに備えて再度実行
  var obs = new MutationObserver(function(){ run(); });
  obs.observe(document.body, { childList: true, subtree: false });
})();
